function isMobile() {
  return window.innerWidth <= 600;
}

export default isMobile;
